import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <p className="overline text-muted-foreground">Loading…</p>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
